import { ServiceBase } from '../../../../../../../core/services/ServiceBase'
import HeaderCompanyAnalysisProxy from '../proxies/HeaderCompanyAnalysisProxy'

class HeaderCompanyAnalysisService extends ServiceBase {
  getHeaderCompanyAnalysis(params) {
    return this.applyMemoryCache(
      'companyAnalysis/header/getCompanyInfo',
      params,
      undefined,
      30,
    )(() => HeaderCompanyAnalysisProxy.getHeaderCompanyAnalysis(params))
  }
  getScoreRangesCreditRisk(params) {
    return this.applyMemoryCache(
      'companyAnalysis/header/getScoreRangesCreditRisk',
      params,
    )(() => HeaderCompanyAnalysisProxy.getScoreRangesCreditRisk(params))
  }
  getScoreRangesPerformance(params) {
    return this.applyMemoryCache(
      'companyAnalysis/header/getScoreRangesPerformance',
      params,
    )(() => HeaderCompanyAnalysisProxy.getScoreRangesPerformance(params))
  }
}

const headerCompanyAnalysisService = new HeaderCompanyAnalysisService()
export default headerCompanyAnalysisService
